import React, { Fragment, ReactElement } from 'react';
import { View } from 'react-native';
import { Popout, PopoutProps } from 'src/components/Popout';
import { ScaleIntro } from 'src/components/Animated';
import { Title3, Headline } from 'src/components/Typography';
import { Separator } from 'src/components/Separator';
import useStyles from './Alert.styles';

export type AlertProps = PopoutProps & {
  type: 'horizontal' | 'vertical';
  title: string;
  description?: string;
  actions: Array<ReactElement>;
};

export const Alert: React.FC<AlertProps> = ({
  visible,
  type,
  title,
  description,
  actions,
  ...props
}) => {
  const s = useStyles();

  return (
    <Popout visible={visible} style={s.root} {...props}>
      <ScaleIntro style={[s.alert]} visible={visible}>
        <View style={s.content}>
          <Title3 weight="semibold">{title}</Title3>
          {description && (
            <Fragment>
              <Separator size="s" />
              <Headline style={s.description}>{description}</Headline>
            </Fragment>
          )}
        </View>
        <View
          style={[
            s.actionsDefault,
            type === 'horizontal' && s.actionsHorizontal,
            type === 'vertical' && s.actionsVertical,
          ]}
        >
          {actions}
        </View>
      </ScaleIntro>
    </Popout>
  );
};
